import {IInsurance} from "@/model/Insurance/Insurance"

export interface IHasInsurance {
    getInsurance(): IInsurance | null
    setInsurance(insurance: IInsurance): void
}

function hasInsurance<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasInsurance {
        private insurance: IInsurance | null = null
        
        constructor(...args: any[]) {
            super(...args);
        }

        public getInsurance(): IInsurance | null {
            return this.insurance
        }
        public setInsurance(insurance: IInsurance): void {
            this.insurance = insurance
        }
    };
}

export default hasInsurance